import configInfo from "./config.json"
import axios from "axios";

export const THUMB_URL = `${configInfo.BASE_URL}/serve_file/thumb/`;

export const ORIGINAL_URL = `${configInfo.BASE_URL}/serve_file/original/`;

export const getThumbUrl = function (code) {
  return THUMB_URL + code;
}

export const getFileUrl = function (code) {
  return ORIGINAL_URL + code;
}

export const getPaymentGateway = function (code) {
  return configInfo.PAYMENT_URL + code;
};

export const getBaseUrl = function () {
  return configInfo.BASE_URL;
};

export const downloadFile = async (uri, data, excel_name) => {
  try {
    let response;
    if (data) {
      const new_data = new URLSearchParams(data).toString()
      response = await axios.get(`${configInfo.BASE_URL}/${uri}?${new_data}`, {
        responseType: 'blob', // Important to set responseType to 'blob' for file downloads
      });
    } else {
      response = await axios.get(`/${configInfo.BASE_URL}${uri}`, {
        responseType: 'blob', // Important to set responseType to 'blob' for file downloads
      });
    }


    // Step 2: Handle the response as a Blob (binary data)
    const blob = response.data;

    // Step 3: Create a URL for the Blob object
    const downloadUrl = window.URL.createObjectURL(blob);

    // Step 4: Create an anchor element and trigger a download
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `${excel_name}.xlsx`; // Set default file name
    document.body.appendChild(link);
    link.click();

    // Clean up: remove the link element after download
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl); // Release the object URL

  } catch (error) {
    console.error('Error downloading file:', error);
  }
};